/**
 * @license Copyright (c) 2003-2018, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

/**
 * @module utils/dom/istext
 */

/**
 * Checks if the object is a native DOM Text node.
 *
 * @param {*} obj
 * @returns {Boolean}
 */
export default function isText( obj ) {
	return Object.prototype.toString.call( obj ) == '[object Text]';
}



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/dom/istext.js
// module id = null
// module chunks = 